"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _actionHandler = _interopRequireDefault(require("../action-handler"));
var _bwaEmptyWidget = require("../../apis/bwa/widgets/bwa-empty-widget");
var _constants = require("../../constants/constants");
var _utils = require("../../utils/utils");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var BwaEmptyWidgetRenderHandler = exports["default"] = /*#__PURE__*/function (_ActionHandler) {
  function BwaEmptyWidgetRenderHandler() {
    (0, _classCallCheck2["default"])(this, BwaEmptyWidgetRenderHandler);
    return _callSuper(this, BwaEmptyWidgetRenderHandler);
  }
  (0, _inherits2["default"])(BwaEmptyWidgetRenderHandler, _ActionHandler);
  return (0, _createClass2["default"])(BwaEmptyWidgetRenderHandler, [{
    key: "execute",
    value: function () {
      var _execute = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.setupMessageListener();
              _context.next = 3;
              return this.render();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function execute() {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }, {
    key: "render",
    value: function () {
      var _render = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var iframe;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!document.getElementById(_constants.IFRAME_IDS.EMPTY_WIDGET)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              iframe = (0, _bwaEmptyWidget.bwaEmptyWidget)(_constants.IFRAME_IDS.EMPTY_WIDGET, _constants.CSS_CLASSES.EMPTY_WIDGET);
              document.body.appendChild(iframe);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "setupMessageListener",
    value: function setupMessageListener() {
      var bwaOrigin = new URL(_constants.BWA_ENDPOINT).origin;
      window.addEventListener(_constants.EVENT_TYPE.MESSAGE, function (event) {
        var _event$data, _event$data2;
        if (event.origin !== bwaOrigin || ((_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.widgetId) !== _constants.IFRAME_IDS.EMPTY_WIDGET) return;
        if (((_event$data2 = event.data) === null || _event$data2 === void 0 ? void 0 : _event$data2.widgetMessageType) === _constants.EVENT_TYPE.CUSTOM.BWA_REPEAT_CUSTOMER_RESOLVED) {
          var _event$data3 = event.data,
            isBwARepeatCustomer = _event$data3.isBwARepeatCustomer,
            ecpSessionId = _event$data3.ecpSessionId;
          sessionStorage.setItem(_constants.SESSION_STORAGE_KEYS.IS_BWA_REPEAT_CUSTOMER, String(!!isBwARepeatCustomer));
          // Fallback only for backward compatibility.
          if (ecpSessionId) {
            (0, _utils.setEcpSessionId)(ecpSessionId);
          }
        }
      });
    }
  }]);
}(_actionHandler["default"]);
//# sourceMappingURL=bwa-empty-widget-render-handler.js.map
